/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name breakdetails
 * @description displays the break details for a given shift for a staff member.
 */
angular.module('mercury.directives.breakdetails', [])
.directive('breakdetails', ["dialog", function(dialog) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'directives/breakdetails/breakdetails.tpl.html',
    link: function(scope, element, attrs) {

      scope.renderAsLink = !!attrs.breakdetailsRenderAsLink;
      if (!!attrs.breakdetailsReadOnly) {
        templateUrl = 'directives/breakdetails/viewbreakdetailsdialog.tpl.html';
      }

      scope.showBreakDetailsDialog = function() {
        dialog.open({
          backdrop: 'static',
          templateUrl: templateUrl,
          controller: 'BreakDetailsCtrl',
          size: 'sm',
          resolve: {
            dialogData: function() {
              return {
                clock: angular.copy(scope.clock)
              };
            }
          }
        });
      };
    }
  };
}]);
